import { OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export function Unsubscribable<T extends { new(...args: any[]): {} }>(base: T) {
  return class extends base implements OnDestroy {
    private destroy$ = new Subject<void>();

    protected takeUntilDestroyed<T>() {
      return takeUntil<T>(this.destroy$);
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
  };
}
